// src/sections/BlogTeaser.jsx
import { Link } from "react-router-dom";
import Section from "../components/ui/Section";
import Button from "../components/ui/Button";
import { POSTS } from "../blog/posts";
import { Calendar, ArrowRight, BookOpen } from "lucide-react";

function formatDate(d) {
    try {
        return new Date(d).toLocaleDateString("de-DE", { year: "numeric", month: "short", day: "2-digit" });
    } catch { return d; }
}

export default function BlogTeaser({ posts = [] }) {
    const list = posts && posts.length ? posts : POSTS;

    return (
        <Section 
            eyebrow="Ratgeber" 
            title="Wissen & Praxis" 
            lead="Erfahre mehr über die waidgerechte Fallenjagd und meine Methoden."
            className="bg-slate-50 dark:bg-slate-900/30 py-20"
        >
            <div className="grid gap-6 lg:gap-8 sm:grid-cols-2 lg:grid-cols-3 pt-10">
                {list.slice(0, 3).map((p, idx) => (
                    <Link 
                        to={`/blog/${p.slug}`}
                        key={p.slug} 
                        data-aos="fade-up"
                        data-aos-delay={idx * 100}
                        className="group flex flex-col rounded-3xl bg-white dark:bg-slate-900 border-2 border-slate-100 dark:border-slate-800 hover:border-brand-300 dark:hover:border-brand-700 transition-all duration-300 hover:shadow-xl hover:shadow-brand-500/10 overflow-hidden"
                    >
                        <div className="relative aspect-[16/10] overflow-hidden">
                            {p.cover ? (
                                <img
                                    src={p.cover}
                                    alt={p.title}
                                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            ) : (
                                <div className="h-full w-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-300 relative overflow-hidden">
                                    <img src="/images/hero.webp" alt="Fallback" className="absolute inset-0 w-full h-full object-cover opacity-20 grayscale" />
                                    <BookOpen className="h-8 w-8 relative z-10" />
                                </div>
                            )}
                            {p.date && (
                                <div className="absolute top-4 left-4 bg-white/95 dark:bg-slate-900/95 backdrop-blur px-3 py-1.5 rounded-full">
                                    <div className="text-[10px] font-bold text-slate-600 dark:text-slate-300">
                                        {formatDate(p.date)}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="p-6 flex flex-col flex-1">
                            <h3 className="text-lg font-heading font-bold text-slate-900 dark:text-white leading-snug group-hover:text-brand-600 transition-colors">
                                {p.title}
                            </h3>
                            <p className="mt-3 text-sm text-slate-500 dark:text-slate-400 line-clamp-2 leading-relaxed flex-1">
                                {p.excerpt}
                            </p>
                            
                            <div className="mt-5 flex items-center gap-2 text-sm font-bold text-brand-600">
                                <span>Weiterlesen</span>
                                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                            </div>
                        </div>
                    </Link>
                ))}
            </div>

            <div className="mt-16 flex justify-center">
                <Button as={Link} to="/blog" variant="outline" className="rounded-2xl px-10 py-4 font-black uppercase text-xs tracking-[0.2em] hover:bg-slate-900 hover:text-white transition-all">
                    Alle Beiträge entdecken
                </Button>
            </div>
        </Section>
    );
}